import React, {Component} from 'react';
import { HideUntilLoaded } from 'react-animation'

export default class CardFatoFake extends Component {

    constructor(props){
        super(props)
    }

    css = {
        width: "100%"
    };

    render() {
        return (
            <div>
                <div className="card weex-card-interno">
                    <header className="card-header" style={this.props.theme.css}>
                        <div className="card-header-title weex-card-header weex-card-header-atividade">
                            {this.props.ff.title ? (this.props.ff.title) : (this.props.theme.name)}
                        </div>
                    </header>
                    <div className="conteudo-card-atividades">
                        <div className="card-image mt-4">
                            <HideUntilLoaded style={this.css}>
                                <figure className="image weex-card-container-imagem">
                                    <img src={this.props.fatoFake.picture} alt="Imagem fato ou fake" className="weex-card-imagem-coaching"/>
                                </figure>
                            </HideUntilLoaded>
                        </div>
                        <div className="card-content">
                            <div className="content weex-card-interno__content weex-card-interno__content__fato-fake">
                                <div dangerouslySetInnerHTML={  {__html: this.props.fatoFake.enunciation}   }></div>
                            </div>
                            <button className="weex-button weex-botao-confirmacao__lado-alado weex-botao-confirmacao__apenas-imagem weex-botao-confirmacao__pequeno" onClick={() => this.props.responderFatoFake(true)}>
                            <div style={{display: "flex", alignItems: "center", padding: "10px"}}>
                                <img alt="fact" src="/positivo.png" className="image is-32x32" style={{marginRight: "5px", marginLeft: "16px"}} />
                                
                            </div>

                            </button>
                            <button className="weex-button weex-botao-confirmacao__lado-alado weex-botao-confirmacao__apenas-imagem weex-botao-confirmacao__pequeno" onClick={() => this.props.responderFatoFake(false)}>
                            <div style={{display: "flex", alignItems: "center", padding: "10px"}}>
                                <img src="/negativo.png" className="image is-32x32" alt="fake" style={{marginRight: "5px", marginLeft: "16px"}} />
                                
                            </div>

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
